export const APP_NAME = 'Weekstead';
export const APP_TAGLINE = 'Your household food, handled.';
